import { Redirect, Route } from "react-router";

export const AuthStop = (props:any)=>{
    const hasToken = localStorage.getItem("token");

    return (
        !hasToken ? <Route {...props}/> : <Redirect to="/home"/> 
    )
}